module.exports = __webpack_public_path__ + "static/media/football-field.43726adb.svg";